import { createRoute } from '@tanstack/react-router'

import { appRoute } from '@/app/routes/app-route'
import { lazyPage } from '@/lib/lazy-page'

// Vite folds this to false in nightly and release builds and drops the branch, so the page never reaches their bundle.
// The dev server and preview image builds (--//build/frontend:dev_tools) keep it.
export const styleGuideRoutes = import.meta.env.DEV || import.meta.env.VITE_DEV_TOOLS === 'true'
  ? [
      createRoute({
        getParentRoute: () => appRoute,
        path: '/dev/style-guide',
        staticData: { title: 'Style guide' },
        component: lazyPage(() => import('./features/style-guide/style-guide.lazy'), 'StyleGuidePage'),
      }),
    ]
  : []
